import { Component, OnInit, Inject, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "src/_services/app.service";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import * as moment from "moment";
import { MatDatepickerInputEvent } from "@angular/material";
import { FormControl, FormGroup, Validators } from "@angular/forms";

type mapEvents = {
  BEventId: string;
  bEventName: string;
  bEventId: string;
  SRevent: string;
  BCompetitionId: string;
  SCompetitionId: string;
  BCompetitionName: string;
  SCompetitionName: string;
  SSportId: string;
};

export interface DialogData {
  eventName: string;
  sportId: string;
  eventId: string;
  startDate: number;
  endDate: number;
  openDate: string;
}

export interface editDialogData {
  bEventId: string;
  sEventId: string;
  sSportId: string;
  sCompetitionName: string;
  bCompetitionName: string;
  sCompetitionId: string;
  openDate: string;
}

const sportIdMap = {
  "4": "sr:sport:21",
  "1": "sr:sport:1",
  "2": "sr:sport:5",
  "7522": "sr:sport:2",
  "7511": "sr:sport:3",
};

const SrSportIdMap = {
  "sr:sport:21": "4",
  "sr:sport:1": "1",
  "sr:sport:5": "2",
  "sr:sport:2": "7522",
  "sr:sport:3": "7511",
};
@Component({
  selector: "app-mapping",
  templateUrl: "./mapping.component.html",
  styleUrls: ["./mapping.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class MappingComponent implements OnInit {
  showAlert = false;
  activeTabIndex = 0;
  disableUnmap = true;
  sportId = new FormControl([]);
  sport = "";
  start: any;
  end: any;
  sportsList: any[] = [];
  OrgSREventsList: any[] = [];
  OrgBFEventsList: any[] = [];
  SREventsList: any[] = [];
  BFEventsList: any[] = [];
  searchEvent = "";
  searchKey = "";

  ProviderId: string = "BetFair";
  BFeventFilter: string = "";
  SReventFilter: string = "";
  unMappedEventList = [];
  orgUnMappedEventList = [];

  showOptions: boolean = true;
  showFilterInput: boolean = false;

  mapEvents: mapEvents = {
    bEventId: "",
    BEventId: "",
    SRevent: "",
    bEventName: "",
    BCompetitionId: "",
    SCompetitionId: "",
    BCompetitionName: "",
    SCompetitionName: "",
    SSportId: "",
  };

  selected: any = {
    startDate: null,
    endDate: null,
  };
  sportSettings: any = {};

  orgMappedEvents: mapEvents[] = [];
  mappedEvents: mapEvents[] = [];

  orgAutoMappedEvents: any[] = [];
  autoMappedEvents: any[] = [];

  UnMappedTableHeders: string[] = [
    "Open Date",
    "Event Id",
    "Event Name",
    "Competition Id",
    "Competition Name",
    "Action",
    "Flag"
  ];

  mappedEventsTableHeaders: string[] = [
    "Open Date",
    "BetFair EventId",
    "BetFair EventName",
    "SportRadar EventId",
    "SR Event Name",
    "SR Competition Name",
    "SR SportID",
    "Actions",
  ];

  autoMappedEventsTableHeaders: string[] = [
    "Open Date",
    "BetFair EventId",
    "BetFair EventName",
    "BetFair Competition Name",
    "SportRadar EventId",
    "SR Event Name",
    "SR Competition Name",
    "Actions",
  ];
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  constructor(
    private appService: AppService,
    private router: Router,
    private dialog: MatDialog,
    private activetedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.sportSettings = {
      singleSelection: true,
      idField: "SportId",
      textField: "SportName",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.selected.startDate = moment().subtract(1, "days").startOf("day");
    this.selected.endDate = moment().add(1, "days").endOf("day");
    this.activetedRoute.queryParams.subscribe((params) => {
      this.sport = params["sportId"];
      this.start = params["startDate"];
      this.end = params["endDate"];
    });
    if (this.start !== undefined && this.end !== undefined) {
      this.selected.startDate = moment(parseInt(this.start))
      this.selected.endDate = moment(parseInt(this.end))
    }
    this.getSportsByProvider(this.ProviderId);
  }

  onFilterChange() {
    this.getMapEvents(
      this.selected.startDate,
      this.selected.endDate,
      sportIdMap[this.sportId.value[0].SportId]
    );
    this.getAutoMapEvents(this.selected.startDate, this.selected.endDate, sportIdMap[this.sportId.value[0].SportId]);
    this.getUnMappedEvents(
      this.sportId.value[0].SportId,
      "BetFair",
      this.selected.startDate,
      this.selected.endDate
    );
  }

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.endDate.diff(this.selected.startDate, "days") > 7) {
      this.showAlert = true;
      this.selected.startDate = moment(
        new Date(new Date().setDate(new Date().getDate() - 4))
      );
      this.selected.endDate = moment(
        new Date(new Date().setDate(new Date().getDate() + 3))
      );
      setTimeout(() => {
        this.showAlert = false;
      }, 7000);
    }
    this.onFilterChange();
  };

  getUnMappedEvents(SportId, ProviderId, startDate, endDate) {
    if (SportId) {
      try {
        this.appService
          .getUnMappedEvents(
            SportId,
            ProviderId,
            startDate.valueOf(),
            endDate.valueOf()
          )
          .subscribe((res) => {
            this.unMappedEventList = res.events;
            this.orgUnMappedEventList = res.events;
          });
      } catch (err) {}
    }
  }

  convertDate(timeInSeconds) {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const date = new Date(timeInSeconds).getDate();
    const month = new Date(timeInSeconds).getMonth() + 1;
    const year = new Date(timeInSeconds).getFullYear();
    const hour = new Date(timeInSeconds).toTimeString().slice(0, 9);

    return date + "/" + month + "/" + year + " " + hour;
  }

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportForBetList(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sportsList = res.sports;
          if (this.sport) {
            const index = this.sportsList.findIndex(sport => sport.SportId.toLowerCase() === this.sport);
          this.sportId.setValue([this.sportsList[index]]);
          this.onFilterChange();
          }
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onBFInput(val) {
    this.BFeventFilter = val;
    this.BFEventsList = this.OrgBFEventsList.filter((i) =>
      i.eventName.toLowerCase().includes(val.toLowerCase())
    );
  }

  BFmapEvent(val) {
    this.mapEvents.BEventId = val.eventId;
    this.mapEvents.BCompetitionId = val.competitionId;
    this.mapEvents.BCompetitionName = val.competitionName;
  }

  SRmapEvent(val) {
    this.mapEvents.SRevent = val.eventId;
    this.mapEvents.SSportId = sportIdMap[this.sportId.value[0].SportId];
    this.mapEvents.SCompetitionId = val.competitionId;
    this.mapEvents.SCompetitionName = val.competitionName;
  }

  onSRInput(val) {
    this.SReventFilter = val;
    this.SREventsList = this.OrgSREventsList.filter((i) =>
      i.eventName.toLowerCase().includes(val.toLowerCase())
    );
  }

  onBFInputId(val) {
    this.BFeventFilter = val;
    this.BFEventsList = this.OrgBFEventsList.filter((i) =>
      i.eventId.toLowerCase().includes(val.toLowerCase())
    );
  }

  onSelectedSportName(SportId) {
    this.sportId.setValue([SportId]);
    this.getEvents("BetFair", this.sportId.value[0].SportId);
    this.getEvents("SportRadar", sportIdMap[this.sportId.value[0].SportId]);
    this.onFilterChange();
  }

  setShowOptions(val) {
    this.activeTabIndex = val.index;
    if (val.index === 0) {
      this.showOptions = true;
    } else {
      this.showOptions = false;
    }

    if (val.index === 1 || val.index === 2) {
      this.showFilterInput = true;
    } else {
      this.showFilterInput = false;
    }
  }

  searchHandlerChange() {
    if (this.searchKey.length >= 1) {
      this.unMappedEventList = this.orgUnMappedEventList.filter((event) => {
        if (
          event.eventId
            .toLowerCase()
            .includes(this.searchKey.toLocaleLowerCase()) ||
          event.eventName
            .toLocaleLowerCase()
            .includes(this.searchKey.toLocaleLowerCase())
        ) {
          return event;
        }
      });
    } else {
      this.unMappedEventList = this.orgUnMappedEventList;
    }
  }

  onBFInputChange() {
    if (this.searchEvent.length >= 1) {
      const filtered = (event) => {
        if (
          event.bEventName
            .toLowerCase()
            .includes(this.searchEvent.toLocaleLowerCase()) ||
          event.bEventId
            .toLocaleLowerCase()
            .includes(this.searchEvent.toLocaleLowerCase())
        ) {
          return event;
        }
      };

      if (this.activeTabIndex === 1) {
        this.autoMappedEvents = this.orgAutoMappedEvents.filter(filtered);
      } else {
        this.mappedEvents = this.orgMappedEvents.filter(filtered);
      }
    } else {
      if (this.activeTabIndex === 1) {
        this.autoMappedEvents = this.orgAutoMappedEvents;
      } else {
        this.mappedEvents = this.orgMappedEvents;
      }
    }
  }

  getEvents(providerId, sportId) {
    try {
      this.appService
        .getEventsBySportsList(providerId, sportId.value[0].SportId)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            if (providerId === "BetFair") {
              this.OrgBFEventsList = res.events;
              this.BFEventsList = res.events;
            } else if (providerId === "SportRadar") {
              this.OrgSREventsList = res.events;
              this.SREventsList = res.events;
            }
          } else {
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
              this.router.navigateByUrl("/login");
            }
          }
        });
    } catch (err) {}
  }

  getMapEvents(startDate, endDate, sportId) {
    try {
      this.appService
        .getMappedEvents(startDate.valueOf(), endDate.valueOf(), sportId)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.orgMappedEvents = res.b2SMapDto;
            this.mappedEvents = res.b2SMapDto;
          } else {
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
              this.router.navigateByUrl("/login");
            }
          }
        });
    } catch (err) {}
  }

  getAutoMapEvents(startDate, endDate, sportId) {
    if (sportId) {
      let payload = {
        startDate: startDate.valueOf(),
        endDate: endDate.valueOf(),
        sportId: sportId,
      }
      try {
        this.appService
          .getB2sMapAutoCandidates(payload)
          .subscribe((res) => {
            if (res.status === "RS_OK") {
              const rows = res.candidates || [];
              this.orgAutoMappedEvents = rows;
              this.autoMappedEvents = rows;
            } else {
              if (res.errorDescription === "Invalid Token!") {
                sessionStorage.clear();
                this.router.navigateByUrl("/login");
              }
            }
          });
      } catch (err) {}
    }
  }

  promoteAutoCandidate(row) {
    if (!row.bEventId) return;
    try {
      this.appService
        .promoteB2sMapAutoCandidate({ bEventId: row.bEventId })
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("Added");
            this.onFilterChange();
          } else {
            this.appService.openErrorBar(res.errorDescription);
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
              this.router.navigateByUrl("/login");
            }
          }
        });
    } catch (err) {}
  }

  postMappedEvents() {
    const payload = {
      bEventId: this.mapEvents.BEventId,
      sEventId: this.mapEvents.SRevent,
      sCompetitionId: this.mapEvents.SCompetitionId,
      sCompetitionName: this.mapEvents.SCompetitionName,
      sSportId: this.mapEvents.SSportId,
    };
    try {
      this.appService.mapEvents(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar("successfully");
          this.getMapEvents(
            this.selected.startDate,
            this.selected.endDate,
            this.sportId.value[0].SportId
          );
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    } catch (err) {}
  }
  openSrEventsModal(event) {
    const dialogRef = this.dialog.open(EventMappingModal, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        eventName: event.eventName,
        sportId: this.sportId.value[0].SportId,
        eventId: event.eventId,
        startDate: this.selected.startDate,
        endDate: this.selected.endDate,
        openDate: event.openDate,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getUnMappedEvents(
        this.sportId.value[0].SportId,
        "BetFair",
        this.selected.startDate,
        this.selected.endDate
      );
      this.getMapEvents(
        this.selected.startDate,
        this.selected.endDate,
        sportIdMap[`${this.sportId.value[0].SportId}`]
      );
    });
  }

  flagEvent(event) {
    const payload = {
      eventId: event.eventId,
      sportId: event.sportId,
      providerId: event.providerName,
      flag: !(event.map_flag),
    };
    try {
      this.appService.flagEvent(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
          this.getUnMappedEvents(this.sportId.value[0].SportId, "BetFair", this.selected.startDate, this.selected.endDate);
          this.getAutoMapEvents(this.selected.startDate, this.selected.endDate, sportIdMap[this.sportId.value[0].SportId]);
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  unMapEvent(event) {
    const payload = {
      bEventId: event.bEventId,
    };
    try {
      this.appService.unMapEvent(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar("Unmapped");
          this.getMapEvents(
            this.selected.startDate,
            this.selected.endDate,
            sportIdMap[`${this.sportId.value[0].SportId}`]
          );
          this.getUnMappedEvents(
            this.sportId.value[0].SportId,
            "BetFair",
            this.selected.startDate,
            this.selected.endDate
          );
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}

  }

  openEditModal(event) {
    const dialogRef = this.dialog.open(EditMappingModal, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        id: event.id,
        bEventName: event.bEventName,
        sSportId: event.sSportId,
        bEventId: event.bEventId,
        sEventId: event.sEventId,
        sCompetitionId: event.sCompetitionId,
        sCompetitionName: event.sCompetitionName,
        openDate: event.open_date,
        createdAt: event.createdAt
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getUnMappedEvents(
          this.sportId.value[0].SportId,
          "BetFair",
          this.selected.startDate,
          this.selected.endDate
        );
      this.getMapEvents(
        this.selected.startDate,
        this.selected.endDate,
        sportIdMap[this.sportId.value[0].SportId]
      );
      }
    });
  }
}

@Component({
  selector: "EventMappingModal",
  templateUrl: "./event-mapping-modal.html",
  styleUrls: ["./mapping.component.scss"],
})
export class EventMappingModal {
  filteredsportRadarEvents = [];
  sportRadarEvents;
  searchEvent = "";
  selectedEvent;
  ngOnInit() {
    this.getSportRadarEvents();
  }
  constructor(
    public dialogRef: MatDialogRef<EventMappingModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private appService: AppService
  ) {}

  onChangeSearchInput(event) {
    if (this.searchEvent.length >= 1) {
      this.filteredsportRadarEvents = this.sportRadarEvents.filter((event) => {
        if (
          event.eventName
            .toLowerCase()
            .includes(this.searchEvent.toLocaleLowerCase()) ||
          event.eventId
            .toLocaleLowerCase()
            .includes(this.searchEvent.toLocaleLowerCase())
        ) {
          return event;
        }
      });
    } else {
      this.filteredsportRadarEvents = this.sportRadarEvents;
    }
  }
  selectEventToMap(event) {
    this.selectedEvent = event;
  }
  getSportRadarEvents() {
    try {
      if (this.data.sportId) {
        if (this.data.sportId) {
          try {
            this.appService
              .getUnMappedEvents(
                this.data.sportId.startsWith("sr")
                  ? this.data.sportId
                  : sportIdMap[this.data.sportId],
                "SportRadar",
                this.data.startDate.valueOf(),
                this.data.endDate.valueOf()
              )
              .subscribe((res) => {
                this.sportRadarEvents = res.events;
                this.filteredsportRadarEvents = res.events;
              });
          } catch (err) {}
        }
      }
    } catch (err) {}
  }
  cancelMapping() {
    this.dialogRef.close();
  }

  mapTheEvent() {
    if (this.selectedEvent) {
      if (this.selectedEvent.eventId) {
        const payload = {
          bEventId: this.data.eventId,
          sEventId: this.selectedEvent.eventId,
          sCompetitionId: this.selectedEvent.competitionId,
          sCompetitionName: this.selectedEvent.competitionName,
          sSportId: this.selectedEvent.sportId,
          opendate: this.data.openDate,
        };
        try {
          this.appService.mapEvents(payload).subscribe((res) => {
            if (res.status === "RS_OK") {
              this.appService.openSuccessBar("successfully");
              this.dialogRef.close();
            } else {
              this.appService.openErrorBar(res.errorDescription);
            }
          });
        } catch (err) {}
      }
    }
  }

  convertDate(timeInSeconds) {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const date = new Date(timeInSeconds).getDate();
    const month = new Date(timeInSeconds).getMonth() + 1;
    const year = new Date(timeInSeconds).getFullYear();
    const hour = new Date(timeInSeconds).toTimeString().slice(0, 9);

    return date + "/" + month + "/" + year + " " + hour;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: "EditMappingModal",
  templateUrl: "./edit-mapping-modal.html",
  styleUrls: ["./edit-mapping.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class EditMappingModal {
  mappingInfo : FormGroup
  openDate;
  constructor(
    public dialogRef: MatDialogRef<EditMappingModal>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    public router: Router,
  ) {}

  ngOnInit() {
    let date = moment(this.data.openDate);
    var stillUtc = moment.utc(date).toDate();
     this.openDate = moment(stillUtc).local().format("YYYY-MM-DD HH:mm:ss");
    this.mappingInfo = new FormGroup({
      bfEventID: new FormControl (this.data.bEventId, Validators.required),
      srEventId: new FormControl (this.data.sEventId, Validators.required),
      // srCompetitionName: new FormControl (this.data.sCompetitionName, Validators.required),
      // srSportId: new FormControl (this.data.sSportId, Validators.required),
      // srCompetitionId: new FormControl (this.data.sCompetitionId, Validators.required),
    });
  }

  confirmMapEditing() {
    const payload = {
      id: this.data.id,
      bEventId: this.mappingInfo.value.bfEventID,
      sEventId: this.mappingInfo.value.srEventId,
      sportId: this.data.sSportId,
      createdAt: this.data.createdAt,
      // sCompetitionId: this.mappingInfo.value.srCompetitionId,
      // sCompetitionName: this.mappingInfo.value.srCompetitionName,
      // sSportId: this.mappingInfo.value.srSportId,
      // opendate: this.data.openDate,
    };
    try {
      this.appService.editB2sMap(payload).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar("successfully");
          this.dialogRef.close(true);
        } else {
          this.appService.openErrorBar(res.errorDescription);
          this.dialogRef.close();
        }
      });
    } catch (err) {}
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
